import React from 'react';
import { Link } from 'react-router-dom';
import './AsSeenIn.css';

const OUTLETS = [
  { name: 'AP News', logo: '/logos/ap-news.png' },
  { name: 'Nexstar', logo: '/logos/nexstar.png' },
  { name: 'CBS', logo: '/logos/cbs.png' },
  { name: 'NBC', logo: '/logos/nbc.png' },
  { name: 'FOX', logo: '/logos/fox.png' },
  { name: 'ABC', logo: '/logos/abc.png' },
  { name: 'The CW', logo: '/logos/the-cw.png' },
  { name: 'WGN-TV Chicago', logo: '/logos/wgn-tv.png' },
  { name: 'National Law Review', logo: '/logos/national-law-review.png' },
  { name: 'EIN Presswire', logo: '/logos/ein-presswire.svg' },
  { name: 'KuCoin', logo: '/logos/kucoin.png' }
];

const AsSeenIn = () => (
  <section className="as-seen-in" aria-labelledby="as-seen-in-title">
    <div className="as-seen-in-container">
      <div className="as-seen-in-head">
        <span id="as-seen-in-title" className="as-seen-in-eyebrow">
          As Seen In
        </span>
        <h2 className="as-seen-in-title">
          Worldwide press coverage across 870+ publications
        </h2>
        <p className="as-seen-in-desc">
          Rayad Group and Rayad Kamal Ayub have been featured by AP News,
          Nexstar affiliate stations, and a global network of finance,
          technology, and legal trade outlets.
        </p>
      </div>

      <div className="as-seen-in-grid">
        {OUTLETS.map((o) => (
          <div key={o.name} className="as-seen-in-logo" title={o.name}>
            <img
              src={o.logo}
              alt={`${o.name} logo`}
              loading="lazy"
              decoding="async"
            />
          </div>
        ))}
      </div>

      <div className="as-seen-in-cta">
        <Link to="/global-media-coverage" className="as-seen-in-link">
          View full coverage register →
        </Link>
      </div>
    </div>
  </section>
);

export default AsSeenIn;
